import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const roundStep = (value: number, step = 1.0) => {
  const inv = 1.0 / step;
  return Math.round(value * inv) / inv;
};

export function getPayoutLocalTimeFromUtc(timeStr: string, utcOffset = 3) {
  const gmt3Time = dayjs.utc(timeStr, "HH:mm").add(-utcOffset, 'hours');
  return gmt3Time.local().format("HH:mm A");
}

export const calculateEstimatedPeriod = (estimateDays: number) => {
  if (estimateDays > 365) {
    return {
      title: 'year',
      value: '',
      symbol: '>',
    };
  }
  if (estimateDays > 30) {
    const months = roundStep(estimateDays / 30, 0.1);
    return {
      title: months > 1 ? 'months' : 'month',
      value: months,
      symbol: '~',
    };
  }

  if (estimateDays > 7) {
    const weeks = roundStep(estimateDays / 7, 0.25);
    return {
      title: weeks > 1 ? 'weeks' : 'week',
      value: weeks,
      symbol: '~',
    };
  }

  const days = roundStep(estimateDays, 0.5);
  if (days >= 1) {
    return {
      title: days === 1 ? 'day' : 'days',
      value: days,
      symbol: '~',
    };
  }

  return {
    title: 'h',
    value: Math.ceil(estimateDays * 24),
    symbol: '~',
  };
};